module.exports = __webpack_public_path__ + "static/bg_transport-b21dc7597c81875fdcf52dd5fdf56f72.jpg";